<template>
    <div class="component-settings-user-invite">
        <div class="row">
            <div class="col-12" :style="$store.state.general.settingsMenuMode === 'vertical' ? {'padding': '0px'} : {}">
                <div class="el-card__header text-left border-settings-header" slot="header">
                    <div class="row center-align-vert">
                        <div class="col-6 center-align-vert">
                            <el-button @click="$router.push({ 'name': 'settings-users'})" class="inline fl mr-10" icon="el-icon-back"></el-button>
                            <h4>Invite user</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <el-card class="box-card" id="main-header" shadow="never"
                         style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                         body-style="background-color: #f4f7fa; padding: 20px 0px;"
                >
                    <el-card class="box-card text-left" shadow="never">
                        <div class="row">
                            <div class="col-12">
                                <p class="text-center mb-0">Send an invitation link</p>
                                <form class="form-signin" @submit.prevent="submit">
                                    <div v-if=errorMessage>
                                        <b-alert show variant="warning">{{ errorMessage }}</b-alert>
                                    </div>
                                    <div v-if=successMessage>
                                        <b-alert show variant="success">{{ successMessage }}</b-alert>
                                    </div>
                                    <div :class="{ 'hasError': $v.form.email.$error }">
                                        <label for="inputEmail" class="sr-only">Email address</label>
                                        <input v-model=form.email type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus>
                                    </div>
                                    <el-button class="btn-block mt-10"  type="primary" native-type="submit" :loading="loading">Send invitation</el-button>
                                </form>
                            </div>
                        </div>
                    </el-card>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
    data () {
        return {
            form: { email: '' },
            errorMessage: null,
            successMessage: null,
            loading: false
        }
    },

    validations: {
        form: {
            email: { required, email }
        }
    },

    methods: {
        submit () {
            this.loading = true
            this.errorMessage = null
            this.successMessage = null
            this.$v.form.$touch()
            if (this.$v.form.$error) return

            // All validations passed, so send invite request to token service
            this.$auth.inviteUser(this.form.email.toLowerCase())
                .then(response => {
                    if (response.status === 200) {
                        this.successMessage = 'Success, ' + this.form.email.toLowerCase() + ' was invited.'
                    } else if (response.status === 401) {
                        this.errorMessage = 'You are not allowed to invite someone.'
                    } else if (response.status === 409) {
                        this.errorMessage = 'This user already exists.'
                    } else {
                        this.errorMessage = 'Something went wrong.'
                    }
                    this.loading = false
                })
                .catch(error => {
                    this.errorMessage = 'Something went wrong, please try again later.'
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss">
.component-settings-user-invite {
    .card-header {
        background-color: #fff;
    }
    .form-signin {
    width: 100%;
    max-width: 500px;
    padding: 15px;
    margin: 0 auto;
    }
    .form-signin .checkbox {
    font-weight: 400;
    }
    .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 14px;
    }
    .form-signin .form-control:focus {
    z-index: 2;
    }
    .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    }
    .form-signin input[type="password"] {
    margin-bottom: 10px;
    margin-top: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    }
}
</style>
